import { render, staticRenderFns } from "./copyRight.vue?vue&type=template&id=1d6908f8&scoped=true"
import script from "./copyRight.vue?vue&type=script&lang=js"
export * from "./copyRight.vue?vue&type=script&lang=js"
import style0 from "./copyRight.vue?vue&type=style&index=0&id=1d6908f8&prod&scoped=true&lang=css"
import style1 from "./copyRight.vue?vue&type=style&index=1&id=1d6908f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6908f8",
  null
  
)

export default component.exports